import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { isEmpty } from 'lodash-es';

import Notification from '../../../components/Notification/Notification';
import PublicHeader from '../../../components/PublicHeader/PublicHeader';
import { updateCandidateQuestions } from '../../../redux/actions/candidateActions';
import { getSkills } from '../../../redux/actions/skillsActions';
import { getCandidateStrengthenQuestions } from '../../../redux/actions/strengthenQuestionActions';

import CandidateQuestionsModal from './CandidateQuestionsModal/CandidateQuestionsModal';
import CandidateQuestionsSuccess from './CandidateQuestionsSuccess/CandidateQuestionsSuccess';

import styles from './CandidateQuestions.module.scss';

const CandidateQuestions = () => {
  const { t } = useTranslation('common');
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const strengthenQuestions = useSelector((state) => state.strengthenQuestionReducer.strengthenQuestions);
  const uuid = searchParams.get('uuid');

  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const updateSuccessCallback = useCallback(() => {
    setShowModal(false);
    setShowSuccess(true);
  }, []);

  const handleReSubmit = useCallback(() => {
    setShowSuccess(false);
    setShowModal(true);
  }, []);

  const successCallback = useCallback((data) => {
    if (!isEmpty(data)) {
      if (data.status !== 'archived' && data.status !== 'hired') {
        setShowModal(true);
      } else {
        setShowSuccess(true);
      }
    }
  }, []);

  useEffect(() => {
    if (uuid) {
      dispatch(getCandidateStrengthenQuestions(uuid, successCallback));
      dispatch(getSkills(strengthenQuestions?.organization_id));
    } else {
      Notification.error(t('validation.invalidUrl'));
    }
  }, [uuid, strengthenQuestions?.organization_id, t]);

  const handleSubmit = useCallback(
    (data) => {
      dispatch(updateCandidateQuestions(uuid, data, updateSuccessCallback));
    },
    [uuid, strengthenQuestions]
  );

  return (
    <div className={styles.rootCotainer}>
      {!isEmpty(strengthenQuestions) && (
        <CandidateQuestionsModal
          data={strengthenQuestions}
          showModal={showModal}
          handleSubmit={handleSubmit}
          handleOnSkip={updateSuccessCallback}
        />
      )}
      <div className={styles.header}>
        <PublicHeader
          organizationName={strengthenQuestions?.organization_name}
          logo={strengthenQuestions?.logo_image_thumb}
        />
      </div>
      {showSuccess && <CandidateQuestionsSuccess data={strengthenQuestions} onClick={handleReSubmit} />}
    </div>
  );
};

export default CandidateQuestions;
